export const trimAddress = (str: string) => {
  if (str.length <= 10) {
    // If the string is already short, return it as is
    return str
  }
  // Keep the first 4 characters, add ellipsis, and then the last 4 characters
  return str.substring(0, 4) + '...' + str.substring(str.length - 4)
}
